export { default } from './UserBoxFooter';
